import BaseEntity from './BaseEntity';
import AutoFixPullRequestFile from './AutoFixPullRequestFile';
export default class AutoFixPullRequest extends BaseEntity {
    constructor(data) {
        super();
        this.files = [];
        this.pullRequestBranchName = this.parseProperty(data, 'pullRequestBranchName');
        this.pullRequestTitle = this.parseProperty(data, 'pullRequestTitle');
        this.repositoryId = this.parseProperty(data, 'repositoryId');
        this.sourceBranchName = this.parseProperty(data, 'sourceBranchName');
        this.vcs = this.parseProperty(data, 'vcs');
        this.files = this.parseProperty(data, 'files').map(issue => new AutoFixPullRequestFile(issue));
    }
}
